import styled from "styled-components";

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #F5F5F5;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const ContentWrap = styled.div`
  padding: 24px;
  background: white;
  margin-top: 8px;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.5;
  text-align: center;
`;

export const Label = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
  text-align: left;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 48px 0 16px;
  border: none;
  border-radius: 10px;
  background-color: #EBEBEB;
  font-size: 15px;
  color: #000;
  outline: none;

  &::placeholder {
    color: #999;
  }
`;

export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
`;

export const PasswordToggleIcon = styled.img`
  width: 20px;
  height: 20px;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
`;

export const BottomButton = styled.button`
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: 432px;
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #1FBC70;
  border-radius: 12px;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }

  &:disabled {
    background-color: #D9D9D9;
    cursor: not-allowed;
  }
`;
